import { apiClient } from './client';

export interface ViewsResponse {
  views: any;
}

export interface ViewsRequest {
  session_id: string;
}

export interface UpdateViewsRequest {
  session_id: string;
  updated_views: any;
}

export const getViews = async (session_id: string): Promise<ViewsResponse> => {
  const response = await apiClient.request({
    method: 'POST',
    url: '/views/get',
    data: {
      session_id
    }
  });

  if (response.statusCode === 200) {
    return response.body;
  } else {
    throw new Error(`Failed to get views: ${response.body}`);
  }
};

export const updateViews = async (session_id: string, updated_views: any): Promise<ViewsResponse> => {
  const response = await apiClient.request({
    method: 'POST',
    url: '/views/put',
    data: {
      session_id,
      updated_views
    }
  });

  if (response.statusCode === 200) {
    return response.body;
  } else {
    throw new Error(`Failed to update views: ${response.body}`);
  }
};

